import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tableTitle',
    standalone: true,
})
export class TableTitlePipe implements PipeTransform {
    transform(value: string | number): {
        title: string;
        isNumeric: boolean;
    } {
        if (value === null || value === undefined) {
            return {
                title: '',
                isNumeric: false,
            };
        }

        const stringValue = value.toString();

        // Check if the value is numeric
        const isNumeric = !isNaN(Number(stringValue)) && isFinite(Number(stringValue));

        // Process the title
        let processedTitle = stringValue;

        // Split on underscores and replace with spaces
        processedTitle = processedTitle.replace(/_/g, ' ');

        // Apply text-transform: capitalize
        processedTitle = this.capitalizeText(processedTitle);

        return {
            title: processedTitle,
            isNumeric,
        };
    }

    private capitalizeText(text: string): string {
        return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    }
}
